import { refs, dispatchEvent } from '../modules/utils.js';

class ImagesRow extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await new Promise(resolve => setTimeout(resolve, 0));
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    if (document.body.classList.contains('page-lightbox')) {
      this.refs.images?.forEach((el) => el.addEventListener('click', () => this.#toggleGallery(el)));
    }

    this.refs.videos?.forEach((el) => {
      el.addEventListener('click', () => {
        dispatchEvent('videobox:play', {
          src: el.src,
          title: el.dataset.title,
        });
      });
    });
  }

  #toggleGallery(el) {
    const pictures = Array.from(document.querySelectorAll('images-row picture'));
    const items = Array.from(pictures).map((el) => {
      return {
        type: 'image',
        imageWideUrl: el.dataset.src,
        imageSmallUrl: el.querySelector('source:nth-child(1)').srcset,
        imageMediumUrl: el.querySelector('source:nth-child(2)').srcset,
        imageLargeUrl: el.querySelector('source:nth-child(3)').srcset,
        name: document.body.dataset.title,
      };
    });
    dispatchEvent('archivefeed:gallery', {
      index: pictures.indexOf(el),
      items
    });
  }
}

customElements.define('images-row', ImagesRow);
